<template>
  <v-alert
    v-if="featureEnabled('accountStatus')"
    type="info"
    :icon="false"
    outlined
  >
    <v-row
      align-content="center"
      class="account-credits-text"
    >
      <v-col class="font-weight-bold">
        <help-button
          class="mr-2"
          small
          :help-url="helpUrl"
        />
        Remaining credits:
        <span v-if="loaded">{{ credits }}</span>
        <v-progress-circular
          v-else
          indeterminate
          size="16"
          width="2"
        />
      </v-col>
      <v-col
        v-if="loaded && !hidePlan"
        cols="12"
        lg="7"
        class="font-weight-bold"
      >
        Plan: {{ currentSubscription }}
      </v-col>
      <v-col
        v-if="!hidePlan"
        lg="2"
      >
        <v-btn
          color="primary"
          :to="{ name: 'accountStatus' }"
        >
          Manage plan
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import HelpButton from '@/components/HelpButton'

export default {
  name: 'AccountCredits',
  components: { HelpButton },
  props: {
    hidePlan: { type: Boolean, default: false }
  },
  data() {
    return {
      loaded: false,
      // TODO: help URL to credit guide
      helpUrl: 'https://www.authentigate.io/pricing'
    }
  },
  computed: {
    credits() {
      return this.accountStatus.credits
    },
    subscribed() {
      return this.accountStatus.subscribed
    },
    currentSubscription() {
      return this.subscribed
        ? this.accountStatus.subscription.name
        : 'Free trial'
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_accountStatus']).then(() => {
      this.loaded = true
    })
    this.mapStates(['accountStatus'])
    this.mapGetters(['featureEnabled'])
  }
}
</script>
<style lang="scss" scoped>
.account-credits-text {
  line-height: 2.5rem;
}
</style>
